import React from "react";

import HomepageImage from "./Components/01-Iphone/index";
import TextContent from "./Components/02-Text/index";
import Countries from "./Components/03-Countries/index";
import { getEnv } from "src/utils";
import { HPSetEnv } from "./Redux/Action";
import { useDispatch } from "react-redux";
import { AppHeader } from "src/Common/Components/AppHeader";
import { AppFooter } from "src/Common/Components/AppFooter";

const HomePage = () => {
  const env = getEnv();
  const dispatch = useDispatch();
  if (env !== undefined) {
    dispatch(HPSetEnv({ env: env }));
  }

  return (
    <div style={{ width: "100%" }}>
      <AppHeader />
      <div className="homepage-wrapper">
        <div>
          <HomepageImage />
        </div>
        <div>
          <TextContent />
          <Countries />
        </div>
      </div>
      <AppFooter />
    </div>
  );
};

export default HomePage;
